import React, { useMemo } from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import { FiltersOption } from "./constants";
import { MD } from "./mdTheme";

const MdPeriodSelect = ({
  value,
  onChange,
  options = FiltersOption,
  fallbackLabel = "ALL",
}) => {
  const selectedValue = useMemo(() => {
    if (value && typeof value === "object" && value.value != null) {
      return value.value;
    }
    const label = typeof value === "string" ? value : fallbackLabel;
    const byLabel = options.find(
      (opt) =>
        opt.label === label ||
        opt.label.toLowerCase() === String(label).toLowerCase(),
    );
    return byLabel?.value ?? options[options.length - 1]?.value;
  }, [value, fallbackLabel, options]);

  const handleChange = (event) => {
    const next = options.find((opt) => opt.value === event.target.value);
    if (next && onChange) onChange(next);
  };

  return (
    <FormControl
      size="small"
      variant="outlined"
      sx={{ flex: "none", maxWidth: 130, minWidth: 88 }}
    >
      <Select
        value={selectedValue}
        onChange={handleChange}
        displayEmpty
        inputProps={{ "aria-label": "period" }}
        MenuProps={{
          disableScrollLock: true,
          PaperProps: { sx: { maxHeight: 280 } },
        }}
        sx={{
          bgcolor: "#fff",
          borderRadius: "4px",
          fontSize: 12,
          fontWeight: 500,
          height: 28,
          minHeight: 28,
          color: MD.fg,
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "#d6d9df" },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: MD.link,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: MD.link,
            borderWidth: 1,
          },
          "& .MuiSelect-select": {
            alignItems: "center",
            display: "flex",
            fontSize: 12,
            fontWeight: 500,
            minHeight: "unset !important",
            py: 0.5,
            pl: 1,
            pr: "28px !important",
          },
          "& .MuiSvgIcon-root": {
            color: MD.muted,
            fontSize: 18,
            right: 4,
          },
        }}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value} dense>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MdPeriodSelect;
